/**
 * Practitioner Facade
 *
 * Stable API surface for practitioner operations.
 * Aggregates actions for presentation layer consumption.
 * @agentic connections
 */

import type { MedplumClient } from "@medplum/core";
import type { Practitioner, PractitionerRole } from "@medplum/fhirtypes";
import { createPractitioner } from "@benchmark/core/actions";
import type { PractitionerFormData } from "@benchmark/core/types";

/**
 * Creates a Practitioner facade instance bound to a MedplumClient.
 * @agentic connections
 */
export function createPractitionerFacade(medplum: MedplumClient) {
  return {
    /**
     * Create a new practitioner and PractitionerRole from form data.
     * @agentic connections
     */
    create: (
      formData: PractitionerFormData,
    ): Promise<{
      practitioner: Practitioner;
      practitionerRole: PractitionerRole;
    }> => {
      return createPractitioner(medplum, { formData });
    },
  };
}
